import { useEffect, useState } from 'react';
import AnchorButton from './subcomponents/anchorButton/anchorButton';
import Logo from './subcomponents/logo/logo';
import './navbarStyle.css'
import MobileMenu from './subcomponents/mobileMenu/mobileMenu';
import LanguageSelector from './subcomponents/languageSelector/languageSelector';

export default function Navbar({data}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])


    return (
        <header className="navbar-container">
            <div className="navbar-wraper">
                <Logo className="logo" />
                <LanguageSelector />
                <nav>
                    {windowWidth <= 1025 ?
                        <MobileMenu />
                    :
                        <div className="navbar-anchor-buttons">
                            {data?.map( (item, index) => (
                                <AnchorButton text={item?.text} href={item?.url} key={index}/>
                            ))}
                        </div>
                    }
                </nav>
            </div>

        </header>
    );
}